import { configureStore } from '@reduxjs/toolkit';
import authReducer from './Auth/authSlice';
import subscriptionReducer from './Subscription/subscriptionSlice';
import projectReducer from './Projects/projectSlice.js';
import laborReducer from './Projects/Labor/laborSlice.js'
import materialReducer from './Projects/Material/materialSlice.js'
import expenses from './Projects/Expense/expenseSlice';
import dailyLogsReducer from './Projects/dailyLogSlice.js';
import overviewReducer from './Projects/overviewSlice.js';
import notificationsReducer from './Notifications/notificationsSlice';
import whatsNewReducer from './Others/WhatsNew/whatsNewSlice.js';
import contactReducer from './Others/Support/contactSlice.js';
import uiFeedbackReducer from './UI/uiFeedbackSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    subscription: subscriptionReducer,
    projects: projectReducer,
    labor: laborReducer,
    materials: materialReducer,
    expenses: expenses,
    dailyLogs: dailyLogsReducer,
    overview: overviewReducer,
    notifications: notificationsReducer,
    whatsNew: whatsNewReducer,
    contact: contactReducer,
    uiFeedback: uiFeedbackReducer,
  },
});
